

document.addEventListener('DOMContentLoaded', () => {
	
	const pageAnimSetUpDoorOpening = new pageAnimationSetUp(".central_text > video");
	
/////////////////////////////////////////////////////////// HANDLER FOR CHANGE SCREEN ORIENTATION EVENT /////////////////////////////
	screen.orientation.addEventListener("change", (event) => {

	pageAnimSetUpDoorOpening.typeOfEvent = "ChangeScreenOrient";

	pageAnimSetUpDoorOpening.setPageToAnimStart();

console.log(pageAnimSetUpDoorOpening.typeOfEvent);
	})
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////// HANDLER FOR RESIZE EVENT THAT CHANGHES SCREEN ORIENTATION /////////////////////////////
	window.addEventListener("resize", (event) => {

	let screen_orient = window.matchMedia('(orientation: portrait)').matches;
//console.log(screen_orient);
//console.log(this.screenOrientation);
	if ((this.screenOrientation !== screen_orient) && (pageAnimSetUpDoorOpening.typeOfEvent !== "ChangeScreenOrient"))
		{   // RESIZE EVENT THAT CHANGES SCREEN ORIENTATION :
			// since a window resize event can be fired when toggling the screen orientation, to be sure that the resize event is not 
			// caused by a screen toggling, upon a screen orientation change we first check if a screen toggling has been fired; if not
			// we can then be sure that the event is of type "ResizeSceen"
			pageAnimSetUpDoorOpening.typeOfEvent = "ResizeScreen";
			pageAnimSetUpDoorOpening.setPageToAnimEnd();

		}

	this.screenOrientation = screen_orient;

//console.log(central_textArt.style.animationName);

console.log(pageAnimSetUpDoorOpening.typeOfEvent);
	})
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////// HANDLER FOR LOAD PAGE EVENT ///////////////////////////////////////////////////////////
	window.addEventListener("load", () => {
		
		pageAnimSetUpDoorOpening.typeOfEvent = "LoadPage";
		
		pageAnimSetUpDoorOpening.setPageToAnimStart();	
console.log(pageAnimSetUpDoorOpening.typeOfEvent);
	});
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////// HANDLER FOR ANIMATION END EVENT ///////////////////////////////////////////////////////////
	pageAnimSetUpDoorOpening.lastAnimatedDomEl.addEventListener("animationend", () => {
	
	pageAnimSetUpDoorOpening.typeOfEvent = "endOfAnim";

	pageAnimSetUpDoorOpening.setPageToAnimEnd();
console.log(pageAnimSetUpDoorOpening.typeOfEvent);
	});
	

})

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////// CLASSES DEFINITION /////////////////////////////////////////////////////

class pageAnimationSetUp {
	constructor(lastAnimatedDomElSelector) {
		this.typeOfEvent = null,
		this.screenOrientation = window.matchMedia('(orientation: portrait)').matches,
		this.styleDomEl = null,
		this.createdStyleTag = false;
		this.lastAnimatedDomEl = document.querySelector(lastAnimatedDomElSelector);
		this.numAnim = 0;
	}

/////////////////////////////////////////  PAGE INITIALIZATION TO ADAPT ANIMATION SETTINGS TO REAL DOOR SIZE /////////////////////////////////////////	
	setPageToAnimStart() {

	const {section_div, left_pan, left_pan_img, right_pan, right_pan_img, central_pan, door_l_img, 
	door_l_box, door_r_img, door_r_box, central_text, central_textArt, central_video} = grabHtmlContentForAnimSetup();

	if (this.typeOfEvent === "LoadPage")
		{
// start the animation with the default article font-size when loading the page
			central_textArt.style.transitionProperty = "none";
			
			if ( central_textArt.classList.contains('tgtFontArt') )
			{
			central_textArt.classList.remove('tgtFontArt');
			}
		}

	if (this.typeOfEvent === "ChangeScreenOrient")
		
		{
// When toggling the screen orientation, reset the default article font-size without transition, before re-starting the animation
		central_textArt.style.transitionProperty = "none";
		
		if ( central_textArt.classList.contains('tgtFontArt') )
			{
			central_textArt.classList.remove('tgtFontArt');
			}
			//

		// When toggling the screen orientation, reset all the animations so that they can be retriggered when the page setup - needed to start 
		//again the animations - is ready
		door_l_box.style.animationName = "none";

		door_r_box.style.animationName = "none";

		central_pan.style.animationName = "none";

		left_pan.style.animationName = "none";

		right_pan.style.animationName = "none";

		left_pan_img.style.animationName = "none";

		right_pan_img.style.animationName = "none";

		section_div.style.animationName = "none";

		central_video.style.animationName = "none";

		central_text.style.animationName = "none";

		central_textArt.style.animationName = "none";
		//

		if (this.createdStyleTag == true)
			{
			this.styleDomEl.remove();
			this.createdStyleTag = false;
			}
		}
		
	let door_l_Rect = door_l_img.getBoundingClientRect();

	let door_l_init_width = door_l_Rect.width;

	//console.log(door_l_init_width);

	let door_l_init_height = door_l_Rect.height;

	//console.log(door_l_init_height);

	let door_r_Rect = door_r_img.getBoundingClientRect();

	let door_r_init_width = door_r_Rect.width;

	//console.log(door_r_init_width);

	let panel_l_flexBasisInit = (( (window.innerWidth / 2) - door_l_init_width ) / window.innerWidth) * 100;

	//console.log(panel_l_flexBasisInit);

	let panel_c_flexBasisInit = 100 - (2 * panel_l_flexBasisInit);

	//console.log(panel_c_flexBasisInit);

	if (this.createdStyleTag == false)
		{
		this.styleDomEl = document.createElement("style");

		let head_div = document.getElementsByTagName("head")[0];

		head_div.appendChild(this.styleDomEl);

		this.createdStyleTag = true;
		}

	this.numAnim++;

//console.log(door_l_init_height);
//console.log(window.getComputedStyle(section_div).getPropertyValue("height"));
//console.log(window.getComputedStyle(section_div).getPropertyValue("min-height"));

	this.styleDomEl.innerHTML = `\n .pageMainSection {
		height: ${door_l_init_height}px;
		--doorHeight: ${door_l_init_height}px;
		--doorWidth: ${door_l_init_width}px;
		--flexBasLeft: ${panel_l_flexBasisInit}%;
		--flexBasRight: ${panel_l_flexBasisInit}%;
		--flexBasCent: ${panel_c_flexBasisInit}%;
	}
	.central_text, .central_panel {
		height: 100%;
	}
	.central_text {
		overflow: hidden;
		padding: 2vmin 0;
		margin: 0;
	}

	.central_text > article {
		line-height: 1.2;
	}

	.centralPanel__image_theme_doorLeft, .centralPanel__image_theme_doorRight, .left_panel_pivot, .right_panel_pivot {
		visibility: visible;
	}
	.centralPanel__image_theme_doorLeft, .centralPanel__image_theme_doorRight, .central_panel > picture {
		display: none;
	}
	.boxLeft, .boxRight {
		display: block;
	}
	.boxLeft, .boxRight, .central_panel, .central_text, .central_text > article, 
	.central_text > video, .leftPanel__image, .rightPanel__image, .left_panel, .right_panel, .pageMainSection {
		animation-play-state: running;
	}
	/*.left_panel {
		flex: 0 0 ${panel_l_flexBasisInit}%;
	}
	.right_panel {
		flex: 0 0 ${panel_l_flexBasisInit}%;
	}
	.central_panel {
		flex: 0 0 ${panel_c_flexBasisInit}%;
	}*/
	/* ${this.numAnim}
	${this.typeOfEvent} */
	\n`;

//console.log(window.getComputedStyle(section_div).getPropertyValue("height"));
//console.log(window.getComputedStyle(section_div).getPropertyValue("min-height"));

// When toggling the screen orientation, retrigger all the animations after the page setup - needed to start again the animations - is ready
	if (this.typeOfEvent === "ChangeScreenOrient")	
		{
			requestAnimationFrame(() => {
				setTimeout(() => {
					door_l_box.style.animationName = "door_l_open";
					door_r_box.style.animationName = "door_r_open";
					central_pan.style.animationName = "resize_cent";
					left_pan.style.animationName = "resize_left";
					right_pan.style.animationName = "resize_right";
					left_pan_img.style.animationName = "open_left";
					right_pan_img.style.animationName = "open_right";
					section_div.style.animationName = "central_sec";
					central_video.style.animationName = "central_video";
					central_text.style.animationName = "central_t";
					central_textArt.style.animationName = "central_font";
				}, 0);
			});
		}
		//
	}
	
	///////////////////////////////////////// PAGE RESET TO ANIMATION'S END VALUES /////////////////////////////////////////
	setPageToAnimEnd() {

	const {section_div, left_pan, left_pan_img, right_pan, right_pan_img, central_pan, door_l_img, 
	door_l_box, door_r_img, door_r_box, central_text, central_textArt, central_video} = grabHtmlContentForAnimSetup();

	if (this.typeOfEvent === "ResizeScreen")  // Screen re-size that changes the screen orientation	
		{
// remove the 3-sec transition on the font-size when the screen re-sizing changes the screen orientation
		central_textArt.style.transitionProperty = "none";
console.log(central_textArt.style);
//
		central_textArt.classList.add('tgtFontArt');
		}

	if (this.createdStyleTag == false)
	{
	this.styleDomEl = document.createElement("style");

	let head_div = document.getElementsByTagName("head")[0];

	head_div.appendChild(style_div);

	this.createdStyleTag = true;
	}

	this.styleDomEl.innerHTML = `\n .boxLeft, .boxRight, .central_panel, .central_text, .central_text > article, 
	.central_text > video, .leftPanel__image, .rightPanel__image, .left_panel, .right_panel, .pageMainSection {
		animation-play-state: paused;
	}
	.pageMainSection {
		--flexBasLeft: 25%;
		--flexBasRight: 25%;
		--flexBasCent: 50%;
		min-height: 70vh;
	}
	.leftPanel__image, .rightPanel__image {
		visibility: visible;
	}
	.left_panel_pivot, .right_panel_pivot {
		visibility: visible;
	}
	.central_text > article, .central_text > video {
		opacity: 1;
	}
	.central_text {
		min-height: 100%;
	//CUSTOMIZATION
	//	background-color: rgb(234, 221, 202);
		background-image: linear-gradient( to right, rgb(234, 221, 202) 1%, rgb(244.5, 238, 228.5) 20%, rgb(250.8, 248.2, 244.4), 
			rgb(244.5, 238, 228.5) 80%, rgb(234, 221, 202) 99%);
			
		box-shadow: 0 0 2vmin 1vmin rgb(0,0,0);
		margin: 1vmin;
		padding: 1%;
	}
	.central_text > article {
		line-height: 1.2;
		width: clamp(40ch, 100%, 60ch);
		/* padding-right: 0;
		padding-bottom: 0; */
	}
	//CUSTOMIZATION
	.central_panel {
		min-height: 100%;
		//height: auto;
	}
	.centralPanel__image_theme_doorLeft, .centralPanel__image_theme_doorRight, .central_panel > picture { 
		//display: none;
		visibility: hidden;
	}
	.centralPanel__image_theme_doorLeft, .centralPanel__image_theme_doorRight, .central_panel > picture {
		display: none;
	}
	.boxLeft, .boxRight {
		visibility: hidden;
	}

	@media screen and (orientation: portrait) {

		.pageMainSection {
			border-left: 4vmin solid transparent;
			border-right: 4vmin solid transparent;
			--flexBasLeft: 0%;
			--flexBasRight: 0%;
			--flexBasCent: 100%;
			min-height: 72vh;
		} 
		.central_text {
			/* background-image: linear-gradient(to right, rgba(210.6, 198.9, 181.8, 0.5), rgba(210.6, 198.9, 181.8, 0.5)), 
			url('data/images/chambord_mirrored.jpg'), 
			linear-gradient(to right, rgba(210.6, 198.9, 181.8, 1), rgba(210.6, 198.9, 181.8, 1)); */
	//CUSTOMIZATION
	//		background-color: transparent;

			/* background-image: linear-gradient( to right, rgba(234, 221, 202, 1) 1%, rgba(210.6, 198.9, 181.8, 0.5) 20%, 
			rgba(210.6, 198.9, 181.8, 0.5), rgba(210.6, 198.9, 181.8, 0.5) 80%, rgba(234, 221, 202, 1) 99%), url('data/images/chambord_mirrored.jpg'); */
			
			background-image: linear-gradient( to right, rgba(234, 221, 202, 0.5) 1%, rgba(244.5, 238, 228.5, 0.5) 20%, rgba(255,255,255,0.35), 
				rgba(244.5, 238, 228.5, 0.5) 80%, rgba(234, 221, 202, 0.5) 99%), ${getComputedStyle(document.documentElement).getPropertyValue("--chambordUrl").replaceAll("../../", "")};
				
			padding: 1% 7%;
	//CUSTOMIZATION
		}
		.central_text > article {
			line-height: 1.6;
			text-shadow: 0.2px 0.2px 0px white, -0.2px -0.2px 0px white;
		}
		p {
			background-color: transparent;
		}
	}\n`;

	console.log(document.getElementsByTagName("head")[0]); 

	door_l_box.style.animationName = "none";

	door_r_box.style.animationName = "none";

	central_pan.style.animationName = "none";

	left_pan.style.animationName = "none";

	right_pan.style.animationName = "none";

	left_pan_img.style.animationName = "none";

	right_pan_img.style.animationName = "none";

	section_div.style.animationName = "none";

	central_video.style.animationName = "none";

	central_text.style.animationName = "none";

	central_textArt.style.animationName = "none";

	if (this.typeOfEvent === "endOfAnim")
		{
		// bring the article font to the target font-size (defined within class 'tgtFontArt') at the end of the animation with a transition of 3sec
		central_textArt.style.transitionProperty = "font-size";
	// CUSTOMIZATION
	//	central_textArt.style.transitionDuration = "3s";
		central_textArt.style.transitionDuration = "0s";
	// CUSTOMIZATION
		central_textArt.classList.add('tgtFontArt');
		//
		}
	}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////
function grabHtmlContentForAnimSetup() {
	
	return {section_div: document.querySelector(".pageMainSection"),
	left_pan: document.querySelector(".left_panel"),
	left_pan_img: document.querySelector(".leftPanel__image"),
	right_pan: document.querySelector(".right_panel"),
	right_pan_img: document.querySelector(".rightPanel__image"),
	central_pan: document.querySelector(".central_panel"),
	door_l_img: document.querySelector(".centralPanel__image_theme_doorLeft"),
	door_l_box: document.querySelector(".boxLeft"),
	door_r_img: document.querySelector(".centralPanel__image_theme_doorRight"),
	door_r_box: document.querySelector(".boxRight"),
	central_text: document.querySelector(".central_text"),
	central_textArt: document.querySelector(".central_text > article"),
	central_video: document.querySelector(".central_text > video"),
	}
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////